var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeAudioArticles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.02 43.01 40.04 39.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 43.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M37.495,43.014H2.505a3,3,0,0,0,0,5.925h34.99a3,3,0,0,0,0-5.925Z",
    transform: "translate(0 -43.014)",
    fill: "#0e2444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M246.135,160.488H228.946a3,3,0,0,0,0,5.925h17.189a3,3,0,0,0,0-5.925Z",
    transform: "translate(-208.64 -149.57)",
    fill: "#0e2444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M246.135,277.955H228.946a3,3,0,0,0,0,5.925h17.189a3,3,0,0,0,0-5.925Z",
    transform: "translate(-208.64 -256.119)",
    fill: "#0e2444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M37.495,402.1H2.505a3,3,0,0,0,0,5.925h34.99a3,3,0,0,0,0-5.925Z",
    transform: "translate(0 -368.731)",
    fill: "#0e2444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M11.184,172.477l13.871-7.915a1.2,1.2,0,0,0,0-2.286l-13.871-7.914c-1.106-.631-2-.11-2,1.163v15.788C9.181,172.588,10.078,173.109,11.184,172.477Z",
    transform: "translate(-8.328 -143.77)",
    fill: "#0e2444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeAudioArticles);
export default __webpack_public_path__ + "static/media/welcome-audio-articles.6505485d6e2bc43548ca04e02e437311.svg";
export { ForwardRef as ReactComponent };